import React from 'react';
import history from '../commons/history';
import { LoginComponent, HomePage, ChangeFirstPassword } from '../pages';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import { useLocation, useNavigate, useParams } from 'react-router-dom/dist';
import NavigationListener from '../modules/NavigationListener';
const RouteComponent = () => {
   return (
      <>
         <Router>
            <NavigationListener />
            <Routes>
               <Route path="/" element={<RouteWrapper Component={LoginComponent} />} />{/* Completed */}
               <Route path="/login" element={<RouteWrapper Component={LoginComponent} />} />{/* Completed */}
               <Route path="/login/:SiteName" element={<RouteWrapper Component={LoginComponent} />} />{/* Completed */}
               <Route path="/changeFirstPassword/:identifier" element={<RouteWrapper Component={ChangeFirstPassword} />} />{/* Completed */}
               <Route path="/rubus/*" element={<RouteWrapper Component={HomePage} />} /> {/* Completed */}
            </Routes>
         </Router>
      </>
   );
};

const RouteWrapper = ({ Component }) => {
   const navigate = useNavigate();
   const location = useLocation();
   const params = useParams();
   return <Component navigate={navigate} location={location} params={params} history={history} />;
};

export default RouteComponent;
